import { useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';

import SpeedIcon from '@mui/icons-material/Speed';

import { RxPaperPlane } from "react-icons/rx";
import { FaRegMessage } from "react-icons/fa6";
import { BsPersonVcard, BsFillPeopleFill, BsFillCartFill } from "react-icons/bs";

import user from "./Images/user.jpg";

import { GoPackage } from "react-icons/go";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.primary[400],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({isSidebarCollapsed}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const userdat= JSON.parse(localStorage.getItem("LoginDetails")) || [];
  const sidebarClass = isSidebarCollapsed ?  'sidebar collapsed':'sidebar ' ;

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          // background: `${colors.blueAccent[400]} !important`,
          backgroundColor: "#070040 !important"
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#E73D19 !important",
        },
        "& .pro-menu-item.active": {
          color: "#E73D19 !important",
        },

        // position: "fixed", // Fixed position
        // top: 0,
        // left: 0,
        // height: "100%", // Full height
        // width: isCollapsed ? "60px" : "250px", // Collapsed and expanded width
        // zIndex: 1, // Ensure it's above other content
        // transition: "width 0.3s", // Smooth transition
      }}
    >
      <ProSidebar collapsed={isCollapsed} className="text-white">
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}

          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.primary[400],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.primary[400]}>
                  Admin
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)} >
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src={user}
                  style={{
                    cursor: "pointer",
                    borderRadius: "50%",
                    color: "white",
                  }}
                />
              </Box>
              <p
                style={{ color: "white", textAlign:"center" , fontSize: "20px" }}
              >
                {" "}
                {userdat.username}
              </p>

              <p
                style={{ color: "white", fontSize: "20px",textAlign:"center" }}
              >
                {" "}
                {/* {userdat.email} */}
              </p>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.primary[400]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                ></Typography>
                <Typography
                  variant="h5"
                  color={colors.primary[400]}
                ></Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Home"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <SubMenu // Add SubMenu for "Account Department"
              title="Vendor Panel"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" Profile "
                to="/Profile"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title=" User Panel "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title="  User Profile "
                to="/Userprofile"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="  Free Registration  "
                to="/Freeregistration"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              {/* 
              <Item
                title="  Free Activation  "
                to="/FreeActivation"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              /> */}
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title="  Edit Income "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" Edit Income "
                to="/Editincome"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              {/* <Item
                title=" Auto Income "
                to="/Autoincome"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              /> */}

              {/* <Item
                title=" Club Income"
                to="/Clubincome"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              /> */}

              <Item
                title=" Cash Back Income "
                to="/Cashbankincome"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <Item
              title=" KYC "
              to="/kyc"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Edit Purchase Income"
              to="/Editpurchaseincome"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Notification"
              to="/Notification"
              icon={<NotificationAddIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Testimonial"
              to="/Testimonial"
              icon={<SpeedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item // Add SubMenu for "Account Department"
              title="Process Income"
              to="/Processincome"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            ></Item>

            {/* <Item
              title=" Awards & Rewards "
              to="/Awardandreword "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            /> */}

            <SubMenu // Add SubMenu for "Account Department"
              title="Bank Account Details"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title="Bank Account List "
                to="/BankDetails"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title="Wallet"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" E-Wallet "
                to="/Ewallet"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            {/* <SubMenu // Add SubMenu for "Account Department"
              title=" Performance Bonus "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" Weekly Performance Bonus "
                to="/weeklyperformance"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu> */}

            <SubMenu // Add SubMenu for "Account Department"
              title=" Cashback "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" View Cashback "
                to="/cashback"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title=" Sales Report "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title="  Day Sales  "
                to="/Daily"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" Weekly Sales  "
                to="/Weekly"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" Monthly Sales "
                to="/Monthly"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="  Yearly Sales  "
                to="/Yearly"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Total Earning Sales "
                to="/TotalEarningsales"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title="PINs "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" PIN Request"
                to="/pin-request"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Generate Free PIN"
                to="/FreePingenration"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" PIN Status"
                to="/PinStatus"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" PIN Transfer"
                to="/PinTransfer"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title=" Support "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" View Complaint "
                to="/viewcomplaint"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title="  Invoices  "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" Generate Invoice  "
                to="/Genrateinvoice"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" View Invoice "
                to="/Viewinvoice"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <Item
              title=" Form 16"
              to="/Formsixteen"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            />

            <SubMenu // Add SubMenu for "Account Department"
              title="E-commerce"
              icon={<BsFillCartFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title="Banner"
                to="/Banner"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              {/* <Item
                title="Additional Category"
                to="/AdditionalCategory"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              /> */}
              <Item
                title="Category"
                to="/Category"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="View All Products "
                to="/PromotionalProduct"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              {/* <Item
                title="Quick Deals"
                to="/QuickDeals"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Online Store"
                to="/OnlineStore"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              /> */}
            </SubMenu>

            <SubMenu // Add SubMenu for "Account Department"
              title="  SEO Panel  "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title=" Generate Invoice  "
                to=""
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title=" View Invoice "
                to=""
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

            <Item
              title="Canonical Tag Manager"
              to="/Canonical"
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            />

            <SubMenu // Add SubMenu for "Account Department"
              title="Social Media Link "
              icon={<BsFillPeopleFill />}
              selected={selected}
              setSelected={setSelected}
            >
              <Item
                title="Facebook Pixel"
                to="/Facebook"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Twitter Pixel"
                to="/Twitter"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Linkedin Pixel"
                to="/Linkedin"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Instagram Pixel"
                to="/Instagram"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Youtube Pixel"
                to="/Youtube"
                icon={<RxPaperPlane />}
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>

          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
